import styled from 'styled-components';

export const ButtonCommit = styled.button`
  color: white;
  margin-top: 2rem;
  text-align: center;
  font-size: 1.3rem;
  width: 20rem;
  padding: 1.2rem;
  cursor: pointer;
  border-radius: 2rem;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  font-weight: bold;
  background: #2680EB;
  margin-bottom: 2rem;
`;



// WEBPACK FOOTER //
// ./src/components/CodeOfHonor/components/styles.js